import Header from "./Header";
// import Footer from "./Footer";

import "./dist/style.css";
function App() {
  return (
    <>
      <div className="app">
        <Header />
        {/* <Main />
      <Footer /> */}
      </div>
    </>
  );
}

export default App;
